import React from "react"

import Layout from "components/Layout"
import DivisionGeografica from "./DivisionGeografica"

const Index = () => {
  return (
    <Layout
      title="División Geográfica"
      components={[{ component: <DivisionGeografica /> }]}
    />
  )
}

export default Index
